"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildBearerTokenInterceptor = void 0;
const InterceptorError_1 = require("./errors/InterceptorError");
const errorCodes_1 = require("./errors/errorCodes");
const buildBearerTokenInterceptor = (tokenRefreshFn) => {
    if (typeof tokenRefreshFn !== "function") {
        throw new InterceptorError_1.InterceptorError({
            code: errorCodes_1.ErrorCodes.TOKEN_REFRESH_MUST_BE_A_FUNCTION,
            message: "In order to use this interceptor, you must also include an async function that returns a fresh token.",
        });
    }
    return async (requestConfig) => {
        requestConfig.headers.Authorization = `Bearer ${await tokenRefreshFn()}`;
        return requestConfig;
    };
};
exports.buildBearerTokenInterceptor = buildBearerTokenInterceptor;
//# sourceMappingURL=buildBearerTokenInterceptor.js.map